export function Chunkify(txt, { callback, maxLat = 200, minLat = 0, maxChunk = 17, minChunk = 3 }) {

    let stop = false
  
    function run(start = 0) {
      let shift = Math.floor(Math.random() * maxChunk) + minChunk
      const chunk = txt.substring(start, start + shift)
      callback?.(chunk)
      if (stop || (start + shift >= txt.length)) {
        return
      }
      const timer = Math.floor(Math.random() * maxLat) + minLat
      setTimeout(() => {
        if (stop) {
          return
        }
        run(start + shift)
      }, timer)
    }
  
    return {
      run,
      stop: () => stop = true
    }
  
  }